import { post, getJson, put } from "@/api/http";
/**
 * 发布问答
 * @param {*} data
 * @param {*} token
 * @returns
 */
export const pubAnswer = (data, token) =>
  post(`${config.cpp}handler/v1/qa`, data, { token });
/**
 * 回答
 * @param {*} data
 * @param {*} token
 * @returns
 */
export const answerAsk = (data, token) =>
  post(`${config.cpp}handler/v1/qa/reply`, data, { token });
/**
 * 获取问答列表
 * @param {*} params
 * @param {*} token
 * @returns
 */
export const askAnswerLists = (params, token) =>
  getJson(`${config.cpp}handler/v1/qa/conf/${params.confId}/list`, params, {
    token,
  });
/***
 * 回答列表
 */
export const answerMoreLists = (params, token) =>
  getJson(`${config.cpp}handler/v1/qa/${params.qaId}/reply`, params, { token });

/**
 * 发布问答
 * @param {*} params
 * @param {*} token
 * @returns
 */
export const publication = (params, token) =>
  put(`${config.cpp}handler/v1/qa/${params.qaId}/publication`, params, {
    token,
  });

/**
 * 分配用户答题
 * @param {*} data
 * @param {*} token
 * @returns
 */
export const replayUser = (data, token) =>
  post(`${config.cpp}handler/v1/qa/allocation`, data, { token });

  /**
   * 开启问答
   * @param {*} params 
   * @param {*} token 
   * @returns 
   */
export const switchAnswer = (params, token) =>
  put(`${config.cpp}handler/v1/qa/webcast/${params.webcastId}/switch`, params, {token});

  /**
   * 查询是否开启问答
   * @param {*} webcastId 
   * @param {*} token 
   * @returns 
   */
export const getSwitchAnswer = (webcastId, token) =>
  getJson(`${config.cpp}handler/v1/qa/webcast/${webcastId}/switch`, {}, {
    token,
  });


/**
 * 增加正在问答
 * @param {*} data 
 * @param {*} token 
 * @returns 
 * 
 */
export const addAnswering = (qaId, token) => post(`${config.cpp}handler/v1/qa/addAnswering/${qaId}`, null, { token });

/**
 * 减少正在问答
 * @param {*} data 
 * @param {*} token 
 * @returns 
 */
export const subAnswering = (data, token) => post(`${config.cpp}handler/v1/qa/subAnswering/${data.qaId}`, null, { token });

/**
 * 查询正在问答
 * @param {*} params 
 * @param {*} token 
 * @returns 
 */
export const getAnswering = (params, token) => getJson(`${config.cpp}handler/v1/qa/getAnswering/${params.qaId}`, null, { token }); 